import { useCallback } from 'react';

export const useHandleSaveError = () => {
  return useCallback((result: { error?: unknown }) => {
    if (result.error) {
      console.error('Save error:', result.error);
    }
  }, []);
};
